var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgActivate = function SvgActivate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1C4.36427 1 1 4.36422 1 8.5C1 12.6357 4.36427 16 8.5 16C12.6357 16 16 12.6357 16 8.5C16 4.36422 12.6357 1 8.5 1Z",
    fill: "#0F8CFF",
    stroke: "#0F8CFF",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2C4.9157 2 2 4.91565 2 8.5C2 12.0843 4.9157 15 8.5 15C12.0843 15 15 12.0843 15 8.5C15 4.91565 12.0843 2 8.5 2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4382 10.0112L5.66854 8.24157C5.51124 8.08427 5.27528 8.08427 5.11798 8.24157C4.96067 8.39888 4.96067 8.63483 5.11798 8.79213L7.4382 11.1124L11.882 6.66854C12.0393 6.51124 12.0393 6.27528 11.882 6.11798C11.7247 5.96067 11.4888 5.96067 11.3315 6.11798L7.4382 10.0112Z",
    fill: "#0F8CFF",
    stroke: "#0F8CFF",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activate.28751bab.svg";
export { ForwardRef as ReactComponent };